export const headerUnit = 'year';
export const headerRoundTo = {smallestUnit: 'year', roundingMode: 'trunc'};
export const headerInterval = {years: 1};
export const headerFormat = {year: 'numeric'};

export const boxDimensions = [3, 4];
export const boxOffset = false;
export const boxInterval = {months: 1};
export const boxEnabled = () => true;
export const boxSelectedRoundTo = {smallestUnit: 'month', roundingMode: 'trunc'};
export const boxSelect = ['year', 'month'];
export const boxFormat = {month: 'short'};
